var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    class: (_vm.isDisabled ? 'bg-gray-600 text-white shadow-gray cursor-default' : _vm.typeShadow + ' ' + _vm.textColor + ' ' + _vm.bgColor + ' ' + _vm.borderColor) + ' h-16 px-5 xl:px-6 2xl:px-4 flex items-center min-w-max-content w-max min-w-max group border ' + _vm.padding + ' leading-4 rounded-md focus:outline-none transition ease-in-out duration-300 transform hover:scale-110',
    attrs: {
      "disabled": _vm.isDisabled
    }
  }, [!_vm.right && _vm.icon != null ? _c('div', {
    class: (_vm.isDisabled ? 'text-white bg-gray-600' : _vm.iconColor + ' ' + _vm.bgColorSquare) + ' inline-flex p-1.5 sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-150'
  }, [_vm.spinner ? _c('span', {
    staticClass: "xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
  }) : _c('icon', {
    staticClass: "xl:h-3 xl:w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5",
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "w-full text-center mx-2",
    class: {
      'hidden xl:block': _vm.icon && _vm.resp
    }
  }, [_c('span', {
    class: _vm.sizeText
  }, [_vm._v(_vm._s(_vm.libelle))])]), _vm._v(" "), _vm.right && (_vm.icon != null || _vm.spinner) ? _c('div', {
    class: (_vm.isDisabled ? 'text-white bg-gray-600' : _vm.iconColor + ' ' + _vm.bgColorSquare) + ' relative inline-flex px-2 py-2 sm:w-auto leading-4 border border-transparent rounded-md transition ease-in-out duration-300 hover:scale-110'
  }, [_vm.spinner ? _c('span', {
    staticClass: "h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5 spinner"
  }) : _c('icon', {
    staticClass: "h-3 w-3 xxl:h-4 xxl:w-4 2xl:h-5 2xl:w-5",
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }